import { render, staticRenderFns } from "./FightReportDiceBreakdown.vue?vue&type=template&id=50d5a6d6&scoped=true"
import script from "./FightReportDiceBreakdown.vue?vue&type=script&lang=js"
export * from "./FightReportDiceBreakdown.vue?vue&type=script&lang=js"
import style0 from "./FightReportDiceBreakdown.vue?vue&type=style&index=0&id=50d5a6d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5a6d6",
  null
  
)

export default component.exports